// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-site-design-brand-preview-dialog {
  display: inline-block;
  width: 100%;
  height: 100%;
}
.fi-site-design-brand-preview-dialog .fi-customer-settings-preview-desktop-bg {
  display: block;
  width: 100%;
  height: 100%;
  background: var(--fi-branded-image-landscape) center center no-repeat;
  background-size: cover;
}
.fi-site-design-brand-preview-dialog .fi-customer-settings-preview-desktop-bg .fi-authenticate-login {
  display: block;
  transform-origin: top left;
  position: absolute;
  top: 0;
  left: 50%;
  pointer-events: none;
}

.fi-customer-settings-preview-panel.cdk-overlay-pane .mat-mdc-dialog-container {
  padding: 0;
}
.fi-customer-settings-preview-panel.cdk-overlay-pane .mat-mdc-dialog-container .mat-mdc-dialog-surface.mdc-dialog__surface {
  padding: 0;
}
.fi-customer-settings-preview-panel.cdk-overlay-pane .mat-mdc-dialog-container .fi-common-two-buttons .fi-dialog-top {
  display: none;
}
.fi-customer-settings-preview-panel.cdk-overlay-pane .mat-mdc-dialog-container .fi-common-two-buttons .mat-mdc-dialog-content.fi-dialog-content {
  height: 100%;
  padding: 0;
  width: 100%;
  margin: 0;
  max-height: 100%;
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./Source/app/fi-site-design/fi-site-design-settings/fi-site-design-brand-editor/fi-brand-editor-preview-card/fi-site-design-brand-preview-dialog/fi-site-design-brand-preview-dialog.component.scss"],"names":[],"mappings":"AAAA;EACI,qBAAA;EACA,WAAA;EACA,YAAA;AACJ;AAAI;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,qEAAA;EACA,sBAAA;AAER;AAAQ;EACI,cAAA;EACA,0BAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,oBAAA;AAEZ;;AAII;EACI,UAAA;AADR;AAEQ;EACI,UAAA;AAAZ;AAGY;EACI,aAAA;AADhB;AAGY;EACI,YAAA;EACA,UAAA;EACA,WAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;AADhB","sourcesContent":[".fi-site-design-brand-preview-dialog {\r\n    display: inline-block;\r\n    width: 100%;\r\n    height: 100%;\r\n    .fi-customer-settings-preview-desktop-bg {\r\n        display: block;\r\n        width: 100%;\r\n        height: 100%;\r\n        background: var(--fi-branded-image-landscape) center center no-repeat;\r\n        background-size: cover;\r\n\r\n        .fi-authenticate-login {\r\n            display: block;\r\n            transform-origin: top left;\r\n            position: absolute;\r\n            top: 0;\r\n            left: 50%;\r\n            pointer-events: none;\r\n        }\r\n    }\r\n}\r\n\r\n.fi-customer-settings-preview-panel.cdk-overlay-pane {\r\n    .mat-mdc-dialog-container {\r\n        padding: 0;\r\n        .mat-mdc-dialog-surface.mdc-dialog__surface {\r\n            padding: 0;\r\n        }\r\n        .fi-common-two-buttons {\r\n            .fi-dialog-top {\r\n                display: none;\r\n            }\r\n            .mat-mdc-dialog-content.fi-dialog-content {\r\n                height: 100%;\r\n                padding: 0;\r\n                width: 100%;\r\n                margin: 0;\r\n                max-height: 100%;\r\n                overflow: hidden;\r\n            }\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
